/**
 * Överenskommelse om avstående från besittningsskydd – Bostad — composition.
 *
 * Connected under a bostadshyresavtal. Landlord, tenant, an optional
 * co-tenant and an optional make/sambo sign; the executed form is then sent
 * to hyresnämnden outside Regta.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Överenskommelse om avstående från besittningsskydd – Bostad';
const FORM_NUMBER = 'Formulär R-10';
const KEY = 'avstaende_besittningsskydd_bostad';
export const avstaendeBesittningsskyddBostadV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: KEY,
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Bostadshyra',
        shortTitle: 'Avstående besittningsskydd (bostad)',
        formNumber: FORM_NUMBER,
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        status: 'active',
        preamble: 'Ansökan till hyresnämnd om godkännande av överenskommelse mellan hyresvärd och hyresgäst om att hyresgästen avstår från sitt besittningsskydd.',
        description: 'Avtal om att hyresgästen avstår från besittningsskydd (rätten att få hyresavtalet förlängt). Motsvarar hyresnämndens blankett HN 2 / HN 4 och utgör samtidigt ansökan till hyresnämnden.',
        numberStyle: 'paragraph',
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', signingLabel: 'Hyresvärd / Uthyrare', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'lessee_primary', label: 'Hyresgäst (primär)', signingLabel: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
            {
                id: 'lessee_co',
                label: 'Medhyresgäst',
                signingLabel: 'Eventuell medhyresgäst',
                role: 'lessee',
                ordinal: 1,
                signs: true,
                help: 'Valfritt — lägg till om kontraktet har två hyresgäster.',
            },
            {
                id: 'spouse',
                label: 'Hyresgästens make/sambo',
                role: 'other',
                ordinal: 0,
                signs: true,
                help: 'Valfritt — make eller sambo signerar för att samtycka när hen har samboendet i lägenheten enligt äktenskapsbalken eller sambolagen.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
        connectedTo: ['bostadshyra'],
        inheritFromParent: {
            parties: 'by-role-ordinal',
            property: true,
            values: [
                { key: 'lease_access_date', fromParentKey: 'lease_start_date' },
                { key: 'lease_contract_number', fromParentKey: 'contract_number' },
            ],
        },
        titleSuffix: { key: 'property_designation', prefix: '' },
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'rubrik', blockRef: `${KEY}.rubrik@v1`, input: {} },
        { instanceId: 'hyresvard', blockRef: `${KEY}.hyresvard@v1`, input: {} },
        { instanceId: 'hyresgaster', blockRef: `${KEY}.hyresgaster@v1`, input: {} },
        { instanceId: 'lagenhetens-adress', blockRef: `${KEY}.lagenhetens-adress@v1`, input: {} },
        { instanceId: 'hyresavtalet', blockRef: `${KEY}.hyresavtalet@v1`, input: {} },
        { instanceId: 'overenskommelsens-innehall', blockRef: `${KEY}.overenskommelsens-innehall@v1`, input: {} },
        { instanceId: 'ansokan', blockRef: `${KEY}.ansokan@v1`, input: {} },
        { instanceId: 'underskrift', blockRef: `${KEY}.underskrift@v1`, input: {} },
        { instanceId: 'hyresnamndens-beslut', blockRef: `${KEY}.hyresnamndens-beslut@v1`, input: {} },
        { instanceId: 'information', blockRef: `${KEY}.information@v1`, input: {} },
    ],
});
//# sourceMappingURL=avstaende_besittningsskydd_bostad.js.map